export default {
    activateuser: {
        headerLabel: 'Onboarding ng gumagamit',
        accountActivation: 'Pag-activate ng account',
        step1: {
            header: 'Maligayang pagdating sa aming platform!',
            subHeader: 'Piliin kung paano mo nais kumonekta sa iyong account',
            description:
                'Para sa isang mas simpleng proseso ng pag-login, inirerekumenda namin na ikonekta mo ang iyong account sa kahit isa sa mga sumusunod na serbisyo.',
            OR: 'o',
            emailAndPassword: 'Gumamit ng iyong sariling email',
        },
        step2: {
            header: 'Gumamit ng email at password',
            description:
                'Ito ang pangunahing email na maiuugnay sa iyong account. Inirerekumenda namin na gumamit ka ng ibang email kaysa sa iyong address sa unibersidad upang mapanatili ang pag-access sa iyong data pagkatapos mong magtapos. Madali mong makontrol kung anong mga email ang nakukuha mo sa amin sa mga setting ng iyong account.',
            invalidEmail: 'Ang ibinigay na email ay hindi isang wastong email.',
            passwordsNotMatch: 'Dapat tumugma ang mga password',
            passwordDescription01:
                'Upang matiyak ang seguridad ng iyong account kailangan mong magtakda ng isang bagong password. Mangyaring lumikha ng isang password na may mga sumusunod:',
            passwordDescription02: 'Minimum na 8 character',
            passwordDescription03: 'Hindi bababa sa isang maliit na character na maliit (a-z)',
            passwordDescription04: 'Hindi bababa sa isang malalaking character (A-Z)',
            passwordDescription05:
                'Hindi bababa sa isang numero o espesyal na simbolo (0-9,! # $ Atbp)',
            passwordDescription06: 'Atleast 6 natatanging mga character',
            repeatPassword: 'Ulitin ang password',
        },
        step3: {
            header: 'Pinapagana ang gumagamit',
            loadingHints: {
                '0': 'Nilo-load ang data ng gumagamit',
                '1': 'Paghahanda ng lahat',
                '2': 'Mga bagong posibilidad sa paligid ng sulok',
                '3': 'Malapit ng matapos!',
            },
            successHeader: 'Ang iyong account ay handa na upang pumunta ngayon!',
            successSubheader: 'Nakapag-access ka na ngayon ng mga eksklusibong tampok!',
            errorHeader: 'Hindi nagawang i-activate ang account',
            ifWrongContact: 'Kung sa palagay mo mali ito, mangyaring makipag-ugnay sa suporta',
            contactForHelp: 'Makipag-ugnay sa tulong',
            goBack: 'Balikan',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Suriin ang aking progreso',
            getStarted: 'Magsimula!',
            getToKnowYourself: 'Kilalanin ang iyong sarili',
            getToKnowYourselfBold: 'Kilalanin ang <strong> iyong sarili </strong>',
            getToKnowYourFuture: 'Alamin ang iyong hinaharap',
            getToKnowYourFutureBold: 'Alamin ang iyong <strong> hinaharap </strong>',
            openAssessments: 'Buksan ang mga pagtatasa',
            openAssessment: 'Buksan ang pagtatasa',
            unlock: 'I-unlock ang mga pagsubok',
            testYourself: 'Subukin ang sarili',
            takeTheFreeTests: 'Kunin ang mga libreng pagsubok',
            youOwnThisProduct: 'Pagmamay-ari mo ang produktong ito',
            startTest: 'Simulan ang pagsubok',
            startTests: 'Magsimula ng mga pagsubok',
            continue: 'Magpatuloy',
            showReport: 'Ipakita ang ulat',
            showYourReports: 'Ipakita ang iyong mga ulat',
            showYourReport: 'Ipakita ang iyong ulat',
            continueFreeTests: 'Ipagpatuloy ang mga libreng pagsubok',
            continueTheTest: 'Ituloy ang pagsubok',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Subukin ang sarili',
                description01:
                    'Maligayang pagdating sa Center ng Mga Pagtasa - dito nagsisimula ang iyong paglalakbay sa iyong karera.',
                description02:
                    'Narito kung saan maaari kang kumuha ng <strong> Aon Mga Pagtatasa </strong>, mga pagsubok na ginamit ng mga nagre-recruit sa buong mundo, na suriin ang iyong kakayahan at kahandaan para sa isang darating na karera.',
                freemium: {
                    description:
                        'Dalhin ang mga pagsubok na ito upang masukat ang iyong mga lakas at makakuha ng mahusay na mga ulat ng iyong mga kasanayan.',
                    price: 'Libre',
                    numTests: '3 pagsubok',
                    timeEstimated: 'tinatayang 27 min',
                },
                premium: {
                    description:
                        'Ito ang <strong> totoong deal </strong>. Dalhin ang pagsubok na 3-in-1 na ito upang malaman kung aling mga landas sa karera ang dapat mong ituloy at makakuha ng isang buong Ulat ng Kandidato.',
                    numTests: '3-in-1 na pagsubok',
                    timeEstimated: 'tinatayang 60 min',
                    sampleReport: '↓ Mag-download ng Halimbawang Ulat',
                    candidateReport: 'Ulat ng Kandidato',
                    candidateReportDescription:
                        'Kapag natapos mo ang mga pagsubok na ito makakakuha ka ng isang buong Ulat ng Kandidato na may isang komprehensibong pangkalahatang ideya ng iyong mga resulta kabilang ang mga tip sa pagpapabuti ng iyong personal na hanay ng kasanayan, kung aling mga kasanayan ang dapat mong bigyang pansin, ang mga pinakamahusay na pagkakataon na magsisimula, kung ano ang dapat mong susunod na hakbang, at iba pa.',
                },
            },
            section2: {
                title: 'Paano ka matutulungan ng mga pagsubok na ito na kumuha ka?',
                t1: 'Malalaman mo ang iyong mga kasanayan sa <strong>',
                t2: 'Malalaman mo ang iyong <strong> potensyal </strong>',
                t3: 'Magkakaroon ka ng isang malinaw na <strong> landas sa karera </strong>',
                t4: 'Mapapalakas mo ang iyong <strong> kumpiyansa </strong>',
            },
            section3: {
                title:
                    'Alamin ang tungkol sa iyong personal na kalakasan at mga pagkakataon sa karera upang himukin ang iyong pag-unlad at progreso ng karera.',
            },
            section4: {
                title: 'Unahan ang iyong mga karibal ngayon',
                description:
                    'sa pamamagitan ng pagkumpleto ng mga pagtatasa na ginamit ng mga recruiter sa buong mundo sa mga kumpanya tulad ng Deloitte, Siemens, Burger King, Vodafone, o P&G.',
            },
            section5: {
                title: 'Mga Madalas Itanong',
                thisPage: 'itong pahina',
                question01: {
                    q: 'Ano ang Mga Pagtatasa ng Aon?',
                    a:
                        'Ang Mga Pagtatasa ng Talento ni Aon ay pandaigdigang kinikilalang mga pagsubok na tumutulong sa mga kumpanya sa buong mundo na makilala ang pinakamagandang kandidato para sa isang trabaho. Sa tulong ng mga pagtatasa ng talento ng mga nagrekrut ay maaaring tumingin nang lampas sa mga CV, mga marka sa paaralan, mga sertipiko sa kolehiyo at mga diploma sa unibersidad upang malaman kung ang isang kandidato ay isang mahusay na tugma. \n                <br><br>\n                Karaniwang nakalaan ang mga solusyon na ito <strong> para sa mga nagre-recruit lamang </strong> - dito, nakakakuha ka ng isang eksklusibong </strong> pagkakataon na magsanay at mauna ang iyong mga resulta kaysa sa iyong pakikipanayam sa trabaho. Karamihan sa mga kandidato ay hindi nakakakuha ng pagkakataong ito, kaya samantalahin ito!',
                },
                question02: {
                    q: 'Kailangan ko bang magbayad upang makuha ang mga pagtatasa na ito?',
                    a:
                        'Maaari kang kumuha ng 4 sa mga pagsubok na ito nang libre - <i> Pag-uugali na nauugnay sa Trabaho </i>, <i> Pangangatuwiran sa Numero </i>, <i> Pang-akdang-mapanirang-iisip </i>, at <i> Inductive- lohikal na Pangangatuwiran </i>. Sinusukat ng mga pagsubok na ito ang iyong mga kasanayan at kakayahan at mahusay na paraan upang malaman ang iyong mga kalakasan at kahinaan. \n\n                <br><br> Gayunpaman, kung nais mong magkaroon ng isang buong pangkalahatang ideya ng iyong mga predisposisyon, kumuha ng mga pananaw sa propesyonal sa ang iyong mga pinakahusay na landas sa karera at gumawa ng isang malaking hakbang patungo sa iyong tagumpay sa hinaharap, maaari mo ring ma-access ang 3-in-1 na pagsubok at makakuha ng isang komprehensibong Ulat ng Kandidato sa € 79. <br> <br> Para sa pinalawig na pag-access, <a href={premiumLink}> mag-click dito </a> at magbayad sa pamamagitan ng card - gumagamit kami ng isang ligtas na paraan ng pagbabayad. \\ n',
                },
                question03: { q: 'Bakit ko kukunin ang mga pagsubok na ito?' },
                question04: {
                    q: 'Paano ako maghahanda para sa mga pagsubok na ito?',
                    a:
                        'Mababasa mo ang lahat tungkol sa mga kinakailangang panteknikal at kung paano ihanda ang iyong sarili para sa mga pagtatasa sa <a href={link} target="_blank"> pahinang ito </a>. Doon ay mahahanap mo rin ang mga materyales na makakatulong sa iyo na maiwasan ito',
                },
                question05: {
                    q: 'Saan pa ako makakahanap ng mga pagtatasa na ito?',
                    a:
                        'Karaniwan, maaaring hilingin sa iyo na kumpletuhin ang mga pagsubok na ito ng iyong recruiter - bukod doon, hindi mo mahahanap ang mga magagamit na ito para sa iyo kahit saan pa. Ito ay isang eksklusibong pagkakataon para sa iyo upang magsanay, alamin ang higit pa tungkol sa iyong sarili at tungkol sa iyong karera sa hinaharap.',
                },
                question06: {
                    q: 'Ilang beses ako makakakuha ng mga pagsubok?',
                    a:
                        'Makakakuha ka lamang ng isang pagkuha para sa bawat pagsubok. Walang retake! Tiyaking mayroon kang mga komportableng kundisyon upang kunin ito upang masulit ang pagkakataong ito. Maaari mong pamilyar ang iyong sarili sa pagsubok sa pamamagitan ng panonood ng mga tagubilin na screencast na video at pagsasagawa ng pagsasanay sa pagsasanay bago kumuha ng pagsubok.',
                },
                question07: {
                    q: 'Sa anong wika ang mga pagsubok na ito?',
                    a:
                        "\\ n Ang default na wika para sa mga pagsubok na ito ay Ingles, gayunpaman, ang bawat isa sa kanila ay may iba't ibang mga wikang mapagpipilian. Maaari mong suriin kung aling mga wika ang magagamit at piliin ang isa na pinakaangkop sa iyo bago kumuha ng pagsubok. \\ n",
                },
                question08: {
                    q:
                        'Mayroon bang isang petsa ng pag-expire sa pinalawig na mga pagsubok sa sandaling magbayad ako para sa kanila?',
                    a:
                        'Hindi! Matapos matanggap ang iyong bayad, maaari kang kumuha ng mga pinalawig na pagsubok kahit kailan mo gusto. Maglaan ng iyong oras upang maghanda at simulan ang mga pagtatasa sa anumang oras na umaangkop sa iyo.',
                },
            },
        },
        center: {
            banner: {
                title: 'Suriin ang iyong progreso',
                subtitle:
                    'Narito ang isang pangkalahatang ideya ng iyong progreso sa mga pagtatasa ng karera',
                moreInfo: 'Karagdagang informasiyon',
                yourProgress: 'Ang iyong progreso',
                quote:
                    'Ang pagtatakda ng mga layunin ay ang unang hakbang sa paggawa ng hindi nakikita sa nakikita.',
            },
            list: {
                timeEstimated: 'tinatayang {minuto} minuto',
                freemium: {
                    intro:
                        '\\ n Ito ang unang hakbang sa iyong personal na paglalakbay sa pag-unlad! <br /> \\ n Dalhin ang mga pagsubok na ito upang masukat ang iyong lakas at makakuha ng mahusay na mga ulat ng iyong mga kasanayan sa n. \\ n',
                },
                premium: {
                    intro:
                        '\\ n Ito ang totoong deal. <br /> \\ n Dalhin ang mga pagsubok na ito upang malaman kung aling mga landas ng karera ang dapat mong ituloy at makakuha ng isang \\ n komprehensibong <strong> Ulat ng Kandidato </strong>. \\ n',
                    description:
                        '\\ n Ang iyong <strong> Ulat ng Kandidato </strong> ay magbibigay sa iyo ng isang komprehensibong \\ n pangkalahatang-ideya ng iyong mga resulta kabilang ang <strong> mga tip </strong> sa pagpapabuti ng iyong \\ n personal na hanay ng kasanayan, kung aling mga kasanayan </strong> dapat mong bigyang pansin, ang \\ n pinakamahusay na <strong> mga pagkakataon </strong> upang magsimula sa, kung ano ang dapat na iyong \\ n <strong> susunod na hakbang </strong>, at higit pa. \\ n',
                },
            },
            instruments: {
                '344': {
                    name: 'Nakagagalak-lohikal na Pag-iisip',
                    description:
                        'Tingnan kung gaano ka kagaling sa paggamit ng kaalaman at paglalapat ng mga panuntunan - sinusukat ng pagsubok na ito ang iyong mga kakayahang analitikal at paglutas ng problema.',
                    estimatedTime: '9',
                },
                '383': {
                    name: 'Inductive-lohikal na Pangangatuwiran',
                    description:
                        'Gaano mo kakilala ang mga panuntunan at ugnayan? Suriin ang pagsubok na ito kung aling sumusukat sa iyong mga kakayahan sa pagsusuri at paglutas ng problema.',
                    estimatedTime: '9',
                },
                '390': {
                    name: 'Pag-uugali na nauugnay sa trabaho',
                    description:
                        'Anong uri ng mga katangian ng pagkatao ng empleyado ang mayroon ka? Alamin sa pamamagitan ng pagsubok na ito na tumutukoy sa iyong mga katangian sa pagkatao na batay sa trabaho.',
                    estimatedTime: '30',
                },
                '721': {
                    name: 'Numero ng Pangangatuwiran',
                    description:
                        'Gaano ka kahusay sa mga crunching number? Sinusukat ng pagsubok na ito ang iyong pag-unawa sa numerong impormasyon at pag-abot sa lohikal na konklusyon.',
                    estimatedTime: '9',
                },
                '5392': {
                    name: 'Gumaganang memorya',
                    description:
                        'Gaano ka kahusay na manatiling nakatuon? Sinusukat ng pagsubok na ito ang kakayahang iproseso at matandaan ang impormasyon sa nakagagambala na mga kapaligiran.',
                    estimatedTime: '15',
                },
                '82013': {
                    name: 'flexTest',
                    description:
                        'Ano ang iyong mga interes? Ang talatanungan na ito ay makakatulong matukoy kung aling mga landas sa karera ang maaari mong ituloy.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Simulan ang iyong mga pagtatasa sa Aon',
            consent:
                'Nauunawaan ko na responsable si Aon para sa aking data na nauugnay sa pagtatasa na ito, at sumasang-ayon sa kanilang mga tuntunin at kundisyon. \\ N Sumasang-ayon din ako na maaaring ilipat ng Highered ang aking pangalan sa Aon upang makabuo ng aking ulat.',
            startTest: 'Simulan ang pagsubok',
            consentErrorTitle: 'Error sa pahintulot',
            consentErrorMessage:
                'Nagkaproblema habang isinumite ang iyong pahintulot. Nakumpirma mo na ba ang iyong email?',
        },
    },
    calendar: {
        header: 'Kalendaryo',
        myCalendar: 'Aking Kalendaryo',
        noCalendar:
            'Ang iyong mga serbisyo sa karera ay hindi pa naisasaaktibo ang tampok na kalendaryo.',
        goBackBtn: 'Balikan',
        calendarNotReady: 'Ang pagpapaandar na "aking kalendaryo" ay hindi pa handa. Malapit na',
        noUpcomingAppointments: 'Wala kang mga paparating na appointment.',
        appointmentMissing: 'Hindi aktibo ang appointment',
        appointmentNotActive:
            'Paumanhin, sinubukan mong tingnan ang isang appointment na wala o hindi aktibo.',
        appointmentNotHavingAvailability:
            'Paumanhin, ang appointment na ito ay walang kakayahang magamit sa ngayon. Bumalik ulit mamaya.',
        appointmentMissingRules: 'Walang kakayahang magamit ang appointment',
        needToCompleteProfile: 'Kumpletuhin ang iyong profile',
        noUpcomingAppointmentsPleaseBook:
            'Mag-book ng isang appointment upang i-unlock ang iyong kalendaryo.',
        bookAppointment: 'Book appointment',
        bookAnotherAppointment: 'Mag-book ng appointment',
        attendedAppointments: 'Mga appointment na dinaluhan mo',
        aboutAppointments: {
            header: 'Tungkol sa mga appointment',
            button: 'Tungkol sa',
            block1: { header: 'Ano ang appointment?' },
            block2: {
                header: 'Sino ang maaari kong makipag-ugnay para sa karagdagang impormasyon?',
            },
        },
        bookAnAppointment: 'Mag-book ng Isang Appointment',
        backToCalendarBtn: 'Bumalik sa kalendaryo',
        backToBookingBtn: 'Bumalik sa listahan ng appointment',
        firstAvailable: 'Magagamit muna',
        loadingAppointment: 'Naglo-load …',
        bookModal: {
            title: 'Kumpirmahin ang booking',
            with: 'Kasama',
            confirm: 'Kumpirmahin',
            continue: 'Magpatuloy',
            cancel: 'Isara',
            first: {
                title: 'Ito ang iyong unang appointment',
                description:
                    'Upang matiyak na nakukuha mo ang imbitasyon sa kaganapan, mangyaring kumpirmahing mayroon kang access sa isang personal na kalendaryo sa pamamagitan ng e-mail account na ito',
                ok: 'OK',
                wrongEmail: 'Maling e-mail?',
            },
            changeEmail: {
                title: 'Piliin ang iyong e-mail sa kalendaryo',
                inputPlaceholder: 'I-type ang email …',
                ok: 'OK',
                back: 'Gamitin ang default',
            },
            unknownErrorHeader: 'Nagkaroon ng error kapag sinusubukang mag-book',
            unknownErrorBody:
                'Mangyaring subukang mag-book ng isa pang oras, at kung hindi ito gumagana makipag-ugnay sa suporta.',
            confirmationHeader: 'Ang iyong appointment ay nai-book!',
            bookedTheFollowing: 'Mga Detalye:',
            emailWillBeSent: 'Ipapadala ang isang e-mail sa',
            withConfirmation: 'humihiling sa iyo na kumpirmahin ang iyong pagdalo.',
        },
        dateDetailsModal: { title: 'Ang mga appointment sa' },
        completedYourProfile:
            'Kailangan mong kumpletuhin ang iyong profile upang makakuha ng pag-access sa system ng kalendaryo',
        toMyProfile: 'I-edit ang Aking Profile',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: 'Gusto ng {name} na makita ang iyong profile',
            content: 'Nais mo bang ibahagi ang iyong profile sa taong ito?',
            share: 'Ibahagi ang profile',
            reject: 'Hindi',
        },
    },
    companyDetail: {
        locations: {
            header: 'Mga lokasyon',
            viewAll: 'Ipakita lahat',
            noLocations: 'Walang lokasyon',
            allLocations: 'Lahat ng mga lokasyon',
        },
        jobModule: {
            header: 'Nangungunang mga posisyon',
            viewAllJobs: 'Tingnan ang lahat ng mga trabaho mula sa {companyName}',
            noPositions:
                'Ang {companyName} ay kasalukuyang walang anumang mga bukas na posisyon sa Highered.',
            defaultLabel: 'Buksan ang posisyon',
        },
        videos: {
            header: 'Mga video',
            noVideos: 'Walang mga video',
            noMoreVideos: 'Wala nang video',
            moreVideosFrom: 'Mas maraming mga video mula sa {companyName}',
        },
        articles: {
            header: 'Mga Artikulo',
            noArticles: 'Walang artikulo',
            noMoreArticles: 'Wala nang mga artikulo',
            moreArticlesFrom: 'Marami pang mga artikulo mula sa {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Lumikha' },
            yearMonthPicker: { defaultSelect: 'Pumili ng isang buwan' },
            localeDropdown: {
                languages: { en: 'Ingles', cn: 'Intsik', fr: 'Pranses' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Patunayan ang iyong e-mail sa paaralan',
                verificationPending: 'Nakabinbin ang pagpapatotoo',
                weHaveSentAnEmail:
                    'Nagpadala kami ng isang e-mail sa \\ n <strong> {studentEmail} </strong> para ma-verify ka ng iyong sarili. Siguraduhin na \\ n suriin ang iyong folder ng spam, tulad ng maraming paaralan ay \\ n medyo mahigpit sa mga papasok na email.',
                verifyMe: 'Patunayan mo ako',
                resendVerifyEmail: 'Muling ipadala ang email ng pagpapatunay',
                cancelVerification: 'Kanselahin ang pag-verify',
                emailSent: 'Ipinadala ang email',
                emailSentMessage:
                    'Matagumpay na naipadala ang email. Kung hindi mo ito natanggap, makipag-ugnay sa amin sa support@highered.global.',
                resendErrorTitle: 'Error sa pagpapadala muli ng email',
                resendErrorMessage:
                    'Hindi maipadala muli ang email sa pag-verify. Mangyaring makipag-ugnay sa amin sa support@highered.global.',
                verificationCancelledTitle: 'Nakansela ang pag-verify',
                verificationCancelledMessage: 'Matagumpay na nakansela ang pag-verify.',
                cancelErrorTitle: 'Error sa panahon ng pagkansela',
                cancelErrorMessage:
                    'Hindi nagawang kanselahin ang pag-verify. Mangyaring makipag-ugnay sa amin sa support@highered.global.',
            },
            verifyModuleDialog: {
                title: 'Patunayan ang iyong e-mail sa paaralan',
                university: 'Institusyonal pang akademya',
                studentEmail: 'Ang iyong pang-akademikong e-mail address',
                studentEmailPlaceholder: 'Email sa akademiko',
                message: 'Mensahe',
                verify: 'Patunayan',
                sendRequest: 'Magpadala ng kahilingan',
                verificationInProcess: 'Pinoproseso ang pag-verify',
                emailHasBeenSentTo:
                    'Isang email ang naipadala sa <strong> {email} </strong>. Sundin ang mga tagubilin doon upang ma-verify ang iyong koneksyon sa <strong> {schoolName} </strong>',
                verificationRequestSentNonAcademic:
                    'Kailangang i-verify ng mga serbisyo sa karera sa <strong> {schoolName} </strong> ang iyong koneksyon. Aabisuhan ka sa pamamagitan ng email kapag nangyari iyon.',
                ifNoEmailRecieved:
                    'Kung hindi mo pa natanggap ang verification mail mangyaring makipag-ugnay sa amin.',
                contactHelp: 'Makipag-ugnay sa amin para sa tulong',
                doNotHaveAcademicEmail: 'Wala akong pang-akademikong email address',
                doubleCheckEmail:
                    'Mangyaring i-double check kung tama ang email address na ito at mayroon kang access dito.',
                haveAcademicEmail: 'Mayroon akong isang email address na pang-akademiko',
                noAcademicEmailInfo:
                    'Kung hindi ka gagamit ng isang pang-akademikong email address ang iyong kahilingan ay kailangang ma-aprubahan nang manu-mano ng mga serbisyo sa karera. Samakatuwid dapat kang magbigay ng isang maikling mensahe upang makilala ang iyong sarili.',
                alreadyVerifiedInfo: 'Na-verify ka na sa paaralang ito.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Aking pahina',
                jobs: 'Mga trabaho',
                companies: 'Mga Kumpanya',
                resources: 'Mga Masterclass',
                assessments: 'Mga pagtatasa',
                countryGuides: 'Mga Patnubay sa Bansa',
                goToHaigui: 'Trabaho sa Tsina',
                signIn: 'Mag-log in / Mag-sign up',
                vfairs: 'Mga Kaganapan sa Virtual',
                events: 'Mga Kaganapan',
                newFeature: 'Bagong Tampok!',
            },
            profileNavigation: { signOut: 'Mag-sign out' },
            sidebar: {
                myPage: 'Aking pahina',
                myProfile: 'Ang aking profile',
                findJobs: 'Humanap ng trabaho',
                findCompanies: 'Maghanap ng mga kumpanya',
                resources: 'Mga Masterclass',
                assessments: 'Mga pagtatasa',
                countryGuides: 'Mga Patnubay sa Bansa',
                goToHaigui: 'Trabaho sa Tsina',
                virtualFairs: 'Mga Kaganapan sa Virtual',
                logOut: 'Mag-log out',
            },
            backToCalendar: 'Bumalik sa kalendaryo',
            allBooths: 'Lahat ng booths',
            home: 'Home',
        },
        smart: {
            companyModule: {
                followJob: 'Idagdag sa mga Paborito',
                followCompany: 'Sundin ang kumpanya',
                unFollowJob: 'Alisin mula sa Mga Paborit',
                unFollowCompany: 'I-unfollow ang kumpanya',
                favoritedTitle: 'Nai-save sa mga paborito',
                favoritedMessage:
                    'Ang posisyon na ito ay nai-save sa iyong mga paborito. Hanapin ang iyong mga paboritong posisyon sa aking pahina.',
                unfavoritedTitle: 'Inalis mula sa mga paborito',
                unfavoritedMessage: 'Ang posisyon na ito ay tinanggal mula sa iyong mga paborito.',
                favoriteErrorTitle: 'May nangyaring mali',
                favoriteErrorMessage: 'Hindi nagawang paborito ang posisyon na ito',
                showAllCompanies: 'Ipakita ang lahat ng mga kumpanya',
                showOnlyCompaniesLiveOnChat: 'Ipakita lamang ang mga kumpanya na live sa chat',
            },
            profileModule: {
                profileCompletion: 'Pagkumpleto ng profile',
                profileCompletionEncouragement:
                    'Ipakita ang iyong sarili sa mga employer sa pamamagitan ng pagkumpleto ng huling {porsyento ng Kaliwa} ng iyong profile',
                gotoProfilePage: 'I-update ang profile',
                profileCompleted: 'Nakumpleto ang profile',
                profileCompletedWhatsNext:
                    'Alam mo bang ang karamihan sa mga nagpapatrabaho ay gumagamit ng mga online na pagtatasa sa kanilang mga proseso sa pagrekrut? Magsanay ngayon at makakuha ng mga pananaw sa iyong mga kalakasan at kahinaan.',
                gotoTestsPage: 'Pumunta sa sentro ng pagtatasa',
                authIndication: {
                    title: 'Hanapin ang iyong pangarap na trabaho',
                    description:
                        'Nais mo ba ng pag-access sa mga posisyon na kakaiba sa iyong paaralan, at mga pagsubok na magpapalaki sa iyong paghahanap sa trabaho? Madaling lumikha ng isang gumagamit gamit ang Google, LinkedIn o Facebook ngayon.',
                    action: 'Tara na',
                },
                toProfileHint: 'Sa aking profile',
                toProfileUncompletedHint:
                    'Ang iyong profile ay hindi 100% kumpleto. Mangyaring magpatuloy sa pamamagitan ng pagkumpleto upang ma-maximize ang iyong kakayahang magamit.',
                profileActions: {
                    addFirstName: 'Magdagdag ng unang pangalan',
                    addLastName: 'Magdagdag ng apelyido',
                    addNationality: 'Magdagdag ng nasyonalidad',
                    addPhoneNumber: 'Idagdag ang numero ng iyong telepono',
                    addLanguage: 'Magdagdag ng isang wika',
                    addEducation: 'Magdagdag ng isang edukasyon',
                    addEmail: 'Idagdag ang iyong email',
                    addGender: 'Idagdag ang iyong kasarian',
                },
            },
            featuredCompanies: { label: 'Tampok na Mga Kumpanya' },
            featuredPositions: { label: 'Mga Itinatampok na Posisyon' },
            featuredResource: {
                header: 'Sumali sa Virtual Conference',
                cta: 'Manood ngayon!',
                wechatSignupHeader:
                    'Sundin ang account ng Highered WeChat upang makakuha ng mga update',
            },
        },
    },
    cts: {
        filterNames: {
            employment_types: 'Mga uri ng trabaho',
            education_level: 'Degrees',
            job_category: 'Mga fields',
            address: 'Mga lokasyon',
            sector: 'Mga Sektor',
            exclude_school_id: 'Ibukod',
            languages: 'Mga Wika',
        },
        excludeSchoolIds: {
            '-1': 'Mga ibinahaging post',
            unknownSchoolId: 'Kasosyo sa Paaralang EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Mga Bachelor',
            MASTERS_OR_EQUIVALENT: 'Mga masters',
            DOCTORAL_OR_EQUIVALENT: 'PHD',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'Buong oras',
            INTERN: 'Internship',
            TEMPORARY: 'Part time',
            PART_TIME: 'Part time',
        },
        startDate: 'Magsimula',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Accounting at pananalapi',
            ADMINISTRATIVE_AND_OFFICE: 'Administratibo at opisina',
            ADVERTISING_AND_MARKETING: 'Advertising at marketing',
            ART_FASHION_AND_DESIGN: 'Art fashion at disenyo',
            BUSINESS_OPERATIONS: 'Mga pagpapatakbo sa negosyo',
            COMPUTER_AND_IT: 'Computer at IT',
            CUSTOMER_SERVICE: 'Serbisyo sa customer',
            EDUCATION: 'Edukasyon',
            HEALTHCARE: 'Pangangalaga sa kalusugan',
            HUMAN_RESOURCES: 'Mga mapagkukunan ng tao',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Pagpapanatili at pag-aayos ng pag-install',
            LEGAL: 'Ligal',
            MANAGEMENT: 'Pamamahala',
            MANUFACTURING_AND_WAREHOUSE: 'Paggawa at bodega',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Mga komunikasyon at pagsusulat ng media',
            OIL_GAS_AND_MINING: 'Enerhiya',
            PROTECTIVE_SERVICES: 'Mga serbisyo ng proteksiyon',
            REAL_ESTATE: 'Real Estate',
            SALES_AND_RETAIL: 'Pagbebenta at tingi',
            SCIENCE_AND_ENGINEERING: 'Agham at engineering',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Mga serbisyong panlipunan at non profit',
            TRANSPORTATION_AND_LOGISTICS: 'Transportasyon at logistics',
        },
        sectors: {
            Consulting: 'Pagkonsulta',
            'Consumer Goods': 'Mga Produkto ng Consumer',
            'Financial Services / Banking': 'Serbisyong Pinansyal / Pagbabangko',
            'Goverment / Public Administration / Non Profit':
                'Pamahalaan / Pamamahala ng Publiko / Nonprofit',
            'International Trade & Development': 'Internasyonal na Kalakal at Pag-unlad',
            Manufacturing: 'Paggawa',
            'Media / Entertainment': 'Media / Libangan',
            'Petroleum / Energy': 'Petrolyo / enerhiya',
            'Pharma / Healthcare / Biotech': 'Pharma / Pangangalaga sa Kalusugan / Biotech',
            'Real Estate / Construction / Infrastructure':
                'Real Estate / Konstruksiyon / Infrastructure',
            'Technology (IT) / Telecom': 'Teknolohiya (IT) / Telecom',
            'Transportations & Logistics': 'Mga Transportasyon at Logistics',
            Other: 'Iba pa',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hong Kong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europa at Sub-Saharan Africa',
            'Hong Kong': 'Hong Kong',
            'Korea, South': 'South Korea',
            'New Zealand': 'New Zealand',
            'Papua-Ny Guinea': 'Papua New Guinea',
            'Puerto Rico': 'Puerto Rico',
            'Saudi Arabia': 'Saudi Arabia',
            'South Africa': 'South Africa',
            'South Korea': 'South Korea',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taiwan',
            'The Seychell Islands': 'Seychelles',
            'United Arab Emirates': 'United Arab Emirates',
            'United Kingdom': 'United Kingdom',
            'Ivory Coast': 'Ivory Coast',
            Afghanistan: 'Afghanistan',
            Algeria: 'Algeria',
            Angola: 'Angola',
            Argentina: 'Argentina',
            Armenia: 'Armenia',
            Australia: 'Australia',
            Austria: 'Austria',
            Azerbaijan: 'Azerbaijan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrain',
            Bangladesh: 'Bangladesh',
            Belarus: 'Belarus',
            Belgium: 'Belgium',
            Botswana: 'Botswana',
            Brazil: 'Brazil',
            Bulgaria: 'Bulgaria',
            Cambodia: 'Cambodia',
            Canada: 'Canada',
            Chile: 'Chile',
            China: 'China',
            Colombia: 'Colombia',
            Congo: 'Congo',
            Croatia: 'Croatia',
            Cyprus: 'Cyprus',
            Czechia: 'Czechia',
            Denmark: 'Denmark',
            Ecuador: 'Ecuador',
            Egypt: 'Egypt',
            Estonia: 'Estonia',
            Ethiopia: 'Ethiopia',
            Fiji: 'Fiji',
            Finland: 'Finland',
            France: 'France',
            Germany: 'Alemanya',
            Ghana: 'Ghana',
            Greece: 'Greece',
            Guernsey: 'Guernsey',
            Hungary: 'Hungary',
            Iceland: 'Iceland',
            India: 'India',
            Indonesia: 'Indonesia',
            Iraq: 'Iraq',
            Ireland: 'Ireland',
            Israel: 'Israel',
            Italy: 'Italy',
            Japan: 'Japan',
            Jersey: 'Jersey',
            Jordan: 'Jordan',
            Kazakhstan: 'Kazakhstan',
            Kenya: 'Kenya',
            Kuwait: 'Kuwait',
            Laos: 'Laos',
            Latvia: 'Latvia',
            Lebanon: 'Lebanon',
            Lithuania: 'Lithuania',
            Luxembourg: 'Luxembourg',
            Malaysia: 'Malaysia',
            Malta: 'Malta',
            Mauritania: 'Mauritania',
            Mauritius: 'Mauritius',
            Mexico: 'Mexico',
            Mongolia: 'Mongolia',
            Morocco: 'Morocco',
            Myanmar: 'Myanmar',
            Namibia: 'Namibia',
            Netherlands: 'Netherlands',
            Nigeria: 'Nigeria',
            Norway: 'Norway',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Panama: 'Panama',
            Paraguay: 'Paraguay',
            Peru: 'Peru',
            Philippines: 'Pilipinas',
            Poland: 'Poland',
            Portugal: 'Portugal',
            Qatar: 'Qatar',
            Romania: 'Romania',
            Russia: 'Russia',
            Senegal: 'Senegal',
            Serbia: 'Serbia',
            Singapore: 'Singapore',
            Slovakia: 'Slovakia',
            Slovenia: 'Slovenia',
            Spain: 'Spain',
            Sudan: 'Sudan',
            Swaziland: 'Swaziland',
            Sweden: 'Sweden',
            Switzerland: 'Switzerland',
            Syria: 'Syria',
            Taiwan: 'Taiwan',
            Tanzania: 'Tanzania',
            Thailand: 'Thailand',
            Tonga: 'Tonga',
            Turkey: 'Turkey',
            Ukraina: 'Ukraine',
            Ukraine: 'Ukraine',
            USA: 'USA',
            Uzbekistan: 'Uzbekistan',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnam',
            Zambia: 'Zambia',
        },
        languages: {
            Aceh: 'Aceh',
            Afrikaans: 'Afrikaans',
            Albanian: 'Albanian',
            Amharic: 'Amharic',
            Arabic: 'Arabic',
            Arakanese: 'Arakanese',
            Armenian: 'Armenian',
            Azeri: 'Azeri',
            Badini: 'Badini',
            Basque: 'Basque',
            Belarusian: 'Belarusian',
            Bengali: 'Bengali',
            Berber: 'Berber',
            Bosnian: 'Bosnian',
            Bulgarian: 'Bulgarian',
            Burmese: 'Burmese',
            Cantonese: 'Cantonese',
            Catalan: 'Catalan',
            Cebuano: 'Cebuano',
            Chechen: 'Chechen',
            Chin: 'Chin',
            Chinese: 'Chinese',
            Croatian: 'Croatian',
            Czech: 'Czech',
            Danish: 'Danish',
            Dari: 'Dari',
            Dutch: 'Dutch',
            English: 'English',
            Estonian: 'Estonian',
            Faroese: 'Faroese',
            Filipino: 'Filipino',
            Finnish: 'Finnish',
            French: 'French',
            German: 'Aleman',
            Greek: 'Greek',
            Greenlandic: 'Greenlandic',
            Hausa: 'Hausa',
            Hebrew: 'Hebrew',
            Hindi: 'Hindi',
            Hungarian: 'Hungarian',
            Icelandic: 'Icelandic',
            Indonesian: 'Indonesian',
            Italian: 'Italian',
            Japanese: 'Japanese',
            Kazakh: 'Kazakh',
            Kinyarwanda: 'Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Korean',
            Kurdish: 'Kurdish',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: 'Latin',
            Latvian: 'Latvian',
            Lingala: 'Lingala',
            Lithuanian: 'Lithuanian',
            Macedonian: 'Macedonian',
            Malagasy: 'Malagasy',
            Malaysian: 'Malaysian',
            Mandarin: 'Mandarin',
            Mongolian: 'Mongolian',
            Nepali: 'Nepali',
            Norwegian: 'Norwegian',
            Oromo: 'Oromo',
            Other: 'Iba pa',
            Panjabi: 'Panjabi',
            Pashto: 'Pashto',
            Persian: 'Persian',
            Polish: 'Polish',
            Portuguese: 'Portuges',
            Punjabi: 'Punjabi',
            Romanes: 'Romanes',
            Romani: 'Romani',
            Romanian: 'Romanian',
            Russian: 'Russian',
            Sami: 'Sami',
            Serbian: 'Serbian',
            Sign_language: 'Sign language',
            Slovak: 'Slovak',
            Slovene: 'Slovene',
            Somali: 'Somali',
            Sorani: 'Sorani',
            Spanish: 'Spanish',
            Swahili: 'Swahili',
            Swedish: 'Swedish',
            Tagalog: 'Tagalog',
            Tamil: 'Tamil',
            Thai: 'Thai',
            Tigrinya: 'Tigrinya',
            Turkish: 'Turkish',
            Ukrainian: 'Ukrainian',
            Urdu: 'Urdu',
            Uyghur: 'Uyghur',
            Vietnamese: 'Vietnamese',
            Wolof: 'Wolof',
        },
    },
    emailverification: {
        headerLabel: 'Pagpapatunay ng e-mail',
        verifyingEmail: 'Pag-verify sa e-mail',
        emailVerifySuccess: 'Ang iyong e-mail ay napatunayan!',
        emailVerifyFailure:
            'Nagkaproblema ... subukang muli sa ibang pagkakataon o makipag-ugnay sa suporta',
        gotoMyPage: 'Bumalik sa Aking Pahina',
    },
    errors: {
        defaultErrorMessage: 'May pagkakamaling naganap!',
        logInErrorText: {
            invalidCredentials: 'Maling username o password',
            inactiveUser:
                'Ang gumagamit na may ibinigay na email ay hindi aktibo. Suriin ang iyong email para sa pagpapatakbo ng account o subukang i-reset ang iyong password.',
            default: 'Hindi nagawang patunayan.',
        },
        registerErrorText: {
            passwordTooShort: 'Ang password ay dapat na atleast 8 digit ang haba',
            emailAlreadyInUse: 'Ginagamit na ang ibinigay na email.',
            emailTaken:
                'Ginagamit na ang email. Kung ginamit mo ang iyong email sa paaralan, maaaring mangyari ito dahil mayroon kang isang gumagamit bago na-upgrade ang platform (sa higheredtalent.org).',
            default: 'Hindi nakalikha ng isang gumagamit.',
        },
        invalidTokenText: {
            default: 'Ang iyong token ay hindi wasto o nag-expire na.',
        },
        passwordErrorText: {
            passwordTooShort: 'Ang password ay dapat na atleast 8 digit ang haba.',
            requireNonAlphanumeric:
                'Dapat maglaman ang password ng kahit isang espesyal na character.',
            requireLowerCase: 'Ang password ay dapat maglaman ng kahit isang maliit na titik.',
            requireUpperCase: 'Ang password ay dapat maglaman ng kahit isang malalaking titik.',
            requireUniqueChars:
                'Dapat maglaman ang password ng hindi bababa sa 6 magkakaibang mga character',
            default: 'Hindi mabago ang password',
        },
        recoverErrorText: {
            userNotFound: 'Wala ang gumagamit! Mangyaring makipag-ugnay sa suporta.',
            userAlreadyActive: 'Na-aktibo na ang gumagamit! \n Mangyaring subukang mag-log in.',
            emailAlreadyInUse:
                'Ginagamit na ang ibinigay na email. \nIf Kung nais mong magpatuloy sa pag-aktibo ng account, subukan ang ibang email o ibang pag-login sa lipunan. Kung hindi man, magpatuloy sa home page, at mag-log in sa iyong account.',
            default:
                'Hindi nagawang isaaktibo ang account. \n Mangyaring subukang muli sa ibang pagkakataon.',
        },
        socialAuthErrorText: {
            errorTitle: 'Hindi makapag-log in sa {provider}',
            invalidProviderGoogle:
                'Ang gumagamit na may ibinigay na email ay hindi konektado sa Google. Mangyaring subukan na halimbawa mag-log in sa LinkedIn, Facebook, o email.',
            invalidProviderFacebook:
                'Ang gumagamit na may ibinigay na email ay hindi konektado sa Facebook. Mangyaring subukan na halimbawa mag-log in sa Google, LinkedIn, o email.',
            invalidProviderLinkedIn:
                'Ang gumagamit na may ibinigay na email ay hindi konektado sa LinkedIn. Mangyaring subukan na halimbawa mag-log in sa Google, Facebook, o email.',
            invalidProviderWeChat:
                'Ang gumagamit na may ibinigay na email ay hindi konektado sa WeChat. Mangyaring subukan na halimbawa mag-log in sa Google, Facebook, o email.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'Ang email na iyong ibinigay ay ginagamit na. Maaaring ito ay dahil mayroon kang isang gumagamit bago na-upgrade ang platform (sa higheredtalent.org). Mangyaring makipag-ugnay sa suporta.',
            invalidEmailDomain:
                'Ang ibinigay na email-domain ay hindi tugma sa ibinigay na unibersidad. Mangyaring piliin ang tamang unibersidad.',
            existingConnection: 'Ang gumagamit ay konektado na sa ibinigay na unibersidad',
            default: 'Hindi nagawang simulan ang pag-verify.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'Ginagamit na ang email',
                default: 'Hindi makapag-update',
            },
        },
    },
    favorites: {
        header: 'Mga paborito ko',
        active: 'Aktibo',
        expired: 'Nag-expire na',
        expiresThisMonth: 'Ang deadline ng aplikasyon sa buwang ito',
        expiresThisWeek: 'Ang deadline ng aplikasyon sa linggong ito',
        expiresLater: 'Ang deadline ng aplikasyon sa paglaon',
        noActiveFavorites: 'Wala kang mga aktibong paboritong posisyon',
        noExpired: 'Wala kang nag-expire na mga paboritong posisyon',
    },
    findcompanies: {
        headerLabel: 'Maghanap ng mga kumpanya',
        companyListLabel: 'Mga Kumpanya',
    },
    findjobs: {
        header: 'Humanap ng trabaho',
        changeFilters: 'Baguhin ang mga filter',
        recruitmentModule: {
            body:
                'Isa ka bang opisyal sa pangangalap, propesyonal sa karera o interesado lamang sa pagkuha ng talento ng mag-aaral?',
            createJob: 'Mag-click dito upang lumikha ng post sa trabaho',
        },
    },
    general: {
        documentTitle: 'Platform ng Global Opportunity',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Kumpirmahin ang password',
        loading: 'Naglo-load',
        ok: 'OK',
        save: 'I-save',
        add: 'Idagdag pa',
        close: 'Isara',
        delete: 'Tanggalin',
        cancel: 'Kanselahin',
        done: 'Tapos na',
        continue: 'Magpatuloy',
        back: 'Bumalik',
        next: 'Susunod',
        finish: 'Tapos na',
        success: 'Tagumpay',
        error: 'Error',
        description: 'Paglalarawan',
        months: {
            '0': 'Jan',
            '1': 'Feb',
            '2': 'Mar',
            '3': 'Apr',
            '4': 'May',
            '5': 'Jun',
            '6': 'Jul',
            '7': 'Aug',
            '8': 'Sep',
            '9': 'Oct',
            '10': 'Nov',
            '11': 'Dec',
        },
        days: {
            '0': 'Sun',
            '1': 'Mon',
            '2': 'Tue',
            '3': 'Wed',
            '4': 'Thur',
            '5': 'Fri',
            '6': 'Sat',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Sinusuri ang iyong nakabinbing pag-verify',
                verifySchoolConnection:
                    'I-verify ang iyong koneksyon sa paaralan upang ma-access ang mga mapagkukunang ito',
                logInToAccessMoreFeatures: 'Libu-libong Mga Pagkakataon sa Internasyonal na Karera',
            },
        },
        minutesShort: 'min',
        poweredBy: 'Pinatatakbo ng',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: "Ang kumpanyang ito ay isang sertipikadong kumpanya na 'Great Place To Work'",
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip:
                    "Ang post na ito ay pagmamay-ari ng isang 'Great Place To Work' na kumpanya",
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified:
                        'Ang {companyName} ay isang sertipikadong Mahusay na Lugar Upang Magtrabaho',
                    readMore: 'Mag-click upang mabasa ang higit pa',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Ang deadline ng aplikasyon',
            location: 'Lokasyon',
            employmentType: 'Uri ng trabaho',
            languageRequirements: 'Mga kinakailangan sa wika',
            workPermitRequirements: 'Mga kinakailangan sa permit sa trabaho',
            preferredEducationField: 'Gustong larangan ng edukasyon',
            preferredEducationLevel: 'Mas gustong antas ng edukasyon',
            jobTags: 'Mga tag',
            apply: 'Mag-apply na ngayon',
            verificationRequired:
                'Kailangan mong i-verify ang iyong e-mail sa paaralan upang mag-apply.',
            verificationRequiredHint:
                'Kailangan mong i-verify ang iyong e-mail sa paaralan upang mag-apply',
            verificationPending: 'Mayroon kang nakabinbing pag-verify sa paaralang ito',
            verificationPendingHint: 'Mayroon kang nakabinbing pag-verify sa paaralang ito',
        },
        invalidJobAd: {
            caption:
                'Paumanhin, ngunit hindi namin makita ang posisyon na ito. Kung naniniwala kang isang error ito, mangyaring makipag-ugnay sa suporta gamit ang chatbox sa ibaba.',
            btn: 'Maghanap ng iba pang mga trabaho',
        },
    },
    mypage: {
        header: 'Aking pahina',
        suggestedPositions: 'Mga iminungkahing posisyon',
        favoriteModule: {
            header: 'Ang aking mga paboritong posisyon',
            seeAll: 'Ipakita lahat',
            noFavorites: 'Wala kang mga aktibong paboritong posisyon',
        },
    },
    recoverpassword: {
        createPassword: 'Lumikha ng isang bagong password',
        newPasswordLabel: 'Bagong password',
        newPasswordPlaceholder: 'Password',
        confirmPasswordLabel: 'Kumpirmahin ang password',
        confirmPasswordPlaceholder: 'Kumpirmahin ang password',
        resetPasswordButton: 'I-reset ang password',
        resettingPassword: 'Pag-reset ng password',
        passwordsNotMatching: 'Ang mga password ay hindi tugma.',
    },
    recoveruser: {
        headerLabel: 'I-recover ang Highered na gumagamit',
        accountActivation: 'Pag-activate ng account',
        step1: {
            header: 'Maligayang pagdating sa aming bagong platform!',
            subHeader: 'Piliin kung paano mo nais kumonekta sa iyong account',
            description:
                'Para sa isang mas simpleng proseso ng pag-login, inirerekumenda namin na ikonekta mo ang iyong account sa kahit isa sa mga sumusunod na serbisyo.',
            OR: 'o',
            emailAndPassword: 'Gumamit ng iyong sariling email',
        },
        step2: {
            header: 'Gumamit ng email at password',
            description:
                'Ito ang pangunahing email na maiuugnay sa iyong account. Inirerekumenda namin na gumamit ka ng ibang email kaysa sa iyong address sa unibersidad upang mapanatili ang pag-access sa iyong data pagkatapos mong magtapos. Madali mong makontrol kung anong mga email ang nakukuha mo sa amin sa mga setting ng iyong account.',
            invalidEmail: 'Ang ibinigay na email ay hindi isang wastong email.',
            passwordsNotMatch: 'Dapat tumugma ang mga password',
            passwordDescription01:
                'Upang matiyak ang seguridad ng iyong account kailangan mong magtakda ng isang bagong password. Mangyaring lumikha ng isang password na may mga sumusunod:',
            passwordDescription02: 'Minimum na 8 character',
            passwordDescription03: 'Hindi bababa sa isang maliit na character na maliit (a-z)',
            passwordDescription04: 'Hindi bababa sa isang malalaking character (A-Z)',
            passwordDescription05:
                'Hindi bababa sa isang numero o espesyal na simbolo (0-9,! # $ Atbp)',
            passwordDescription06: 'Atleast 6 natatanging mga character',
            repeatPassword: 'Ulitin ang password',
        },
        step3: {
            header: 'Pinapagana ang gumagamit',
            loadingHints: {
                '0': 'Nilo-load ang data ng gumagamit',
                '1': 'Paghahanda ng lahat',
                '2': 'Mga bagong posibilidad sa paligid ng sulo',
                '3': 'Malapit ng matapos!',
            },
            successHeader: 'Ang iyong account ay handa na upang pumunta ngayon!',
            successSubheader: 'Nakapag-access ka na ngayon ng mga bagong eksklusibong tampok!',
            errorHeader: 'Hindi nagawang i-activate ang account',
            ifWrongContact: 'Kung sa palagay mo mali ito, mangyaring makipag-ugnay sa suporta',
            contactForHelp: 'Makipag-ugnay sa tulong',
            goBack: 'Balikan',
        },
    },
    resourcesInternal: {
        header: 'Mga mapagkukunan',
        resourceTypeHeader: 'Uri',
        resourceNoContent:
            'Ang iyong paaralan ay hindi pa napapagana ang pagpapaandar na mapagkukunan.',
        resourceFolderNoContent: 'Walang mga magagamit na mapagkukunan sa folder na ito',
        resourceTitleHeader: 'Pamagat',
        resourcePublishDateHeader: 'Nai-publish',
        searchPlaceholder: 'Maghanap para sa pangalan o keyword ...',
        cvTemplateHeader: 'HIGHERED CV TEMPLATE (ATS-FRIENDLY)',
        cvTemplateSubtitle: 'I-download dito!',
    },
    shared: {
        userNavSection: {
            myPage: 'Aking pahina',
            myProfile: 'Ang aking profile',
            myTests: 'Mga pagtatasa',
            myApplications: 'Mga Aplikasyon',
            myFavorites: 'Mga paborito',
            internalResources: 'Mga mapagkukunan',
            calendar: 'Kalendaryo',
            documents: 'Pag-upload ng CV',
        },
        searchModule: {
            searchBar: { label: 'Paghahanap ayon sa pamagat o mga keyword' },
            filters: { clearFilters: 'I-clear ang mga filter' },
            filterLimit: {
                title: 'Naabot ang limitasyon ng filter',
                message: 'Wala nang mapipiling mga filter ng ganitong uri',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Mga Posisyon',
                estimatedCount: 'ca {count} ng {totalCount}',
                knownCount: '{count} ng {totalCount}',
                noMatchFound: 'Hindi mahanap ang anumang bagay na tumutugma sa iyong pamantayan',
            },
            postItem: { applyBefore: 'Ang deadline ng aplikasyon' },
            postCard: { deadline: 'Deadline' },
        },
        loginModule: {
            emailVerificationTip:
                'Maaaring tumagal ng ilang minuto bago maabot nito ang iyong inbox.',
            noEmail: 'Walang email? Mangyaring suriin ang iyong filter ng spam o:',
            logIn: 'Mag log in',
            socialAuthBtns: {
                continueWithFacebook: 'Magpatuloy sa Facebook',
                continueWithGoogle: 'Magpatuloy sa Google',
                continueWithLinkedIn: 'Magpatuloy sa LinkedIn',
                continueWithWeChat: 'Magpatuloy sa WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Mangyaring i-verify ang iyong email',
                weSentAnEmailTo: 'Nagpadala kami ng isang pag-verify sa',
                continueToSignIn: 'Magpatuloy na mag-sign in',
                resendEmail: 'Ipadala muli ang link sa pag-verify',
                newEmailSent: 'Ipinadala ang bagong email',
            },
            registerForm: {
                recommendation:
                    'Inirerekumenda namin na gamitin mo ang iyong personal na email at hindi ang iyong email na \\ n sa paaralan upang matiyak na may access ka sa iyong data pagkatapos mong magtapos.',
                register: 'Magparehistro',
                passwordsNotMatch: 'Ang mga password ay hindi tumutugma',
            },
            logInPaper: {
                useEmail: 'o gamitin ang iyong email',
                noAccount: 'Wala kang account?',
                signUp: 'Mag-sign up',
                logInToAccess: 'Mag-log in upang ma-access ang tampok na ito',
                showAllOptions: 'Ipakita ang lahat ng mga pagpipilian sa pag-login',
                hideAllOptions: 'Magpakita ng mas kaunti',
            },
            logInForm: {
                logIn: 'Mag log in',
                forgotPassword: 'Nakalimutan ang password?',
            },
            forgotPassword: {
                title: 'Humiling ng pag-reset ng password',
                description:
                    'Walang alalahanin - lahat nakakalimutan ang kanilang password paminsan-minsan. \\ N Ipasok ang iyong email sa ibaba upang i-reset ang iyong password',
                resetPassword: 'I-reset ang password',
                emailSentTitle: 'Paparating na ang iyong tulong!',
                emailHasBeenSent:
                    'Isang email ang naipadala sa \\ n <br> \\ n <strong> {email} </strong> \\ n <br> \\ n na may mga tagubilin sa kung paano i-reset ang iyong password. Mangyaring suriin ang iyong \\ n inbox.',
                noEmail: 'Walang email?',
                sendEmailOneMoreTime: 'Magpadala muli ng email',
                resendErrorTitle: 'Error sa panahon ng pag-recover ng password',
                resendErrorMessage:
                    'Hindi makapagpadala ng email sa pag-recover-password. Siguro mali email?',
            },
        },
        universityBadges: {
            addAnotherUniversity: 'Magdagdag ng ibang pamantasan',
            verificationDialog: {
                verifiedStudent: 'Na-verify na mag-aaral na {schoolAbbr}',
                verificationDescription:
                    'Ikaw ay isang na-verify na {schoolAbbr} mag-aaral na may email {email}',
                verificationDescriptionNoEmail: 'Isa kang na-verify na mag-aaral na {schoolAbbr}',
                checkYourEmail: 'Suriin ang iyong email sa {schoolAbbr}.',
                sentEmailDescription:
                    'Nagpadala kami sa iyo ng isang email tungkol sa pag-verify para sa {schoolAbbr} sa {email}. Mangyaring suriin ang iyong email.',
                resendEmail: 'Ipadala muli ang email',
                cancelVerification: 'Kanselahin ang pag-verify',
                notYetVerified: 'Hindi pa na-verify ang pagkakaugnay sa unibersidad.',
                verifyYourAffiliation:
                    'Upang ma-access ang mga tukoy na tampok ng {schoolAbbr} tulad ng mga eksklusibong pag-post sa trabaho at mga mapagkukunan, mangyaring i-verify ang iyong pagkakaugnay.',
                verify: 'Patunayan',
                goToPlatform: 'Pumunta sa platform',
                verificationPending: 'Nakabinbin ang pagpapatotoo',
                verificationPendingDescription:
                    'Ang mga serbisyo sa karera sa {schoolAbbr} ay nagpapatunay sa iyong kahilingan. Makikipag-ugnay sa iyo sa pamamagitan ng email kapag natapos ang pag-verify.',
            },
        },
        universityAvatar: {
            dialogs: {
                verificationDialog: {
                    verifiedStudent: 'Na-verify na mag-aaral na {uniSubDomain}',
                    verifiedStudentWithEmail:
                        'Isa kang na-verify na mag-aaral na {uniSubDomain} kasama ang email {email}',
                    checkEmail: 'Suriin ang iyong email sa {uniSubDomain}.',
                    sentEmailInfo:
                        'Nagpadala kami sa iyo ng isang email tungkol sa pag-verify para sa {uniSubDomain} sa {email}. Mangyaring suriin ang iyong email.',
                    resendEmail: 'Ipadala muli ang email',
                    cancelVerification: 'Kanselahin ang pag-verify',
                    notYetVerified: 'Hindi pa na-verify ang pagkakaugnay sa unibersidad.',
                    resourceAccessInfo:
                        'Upang ma-access ang mga natatanging tampok ng {uniSubDomain} tulad ng mga eksklusibong pag-post sa trabaho at mga mapagkukunan, mangyaring i-verify ang iyong pagkakaugnay.',
                    verificationCancelled: 'Nakansela ang pag-verify',
                    emailSent: 'Ipinadala ang email',
                },
            },
        },
        termsAndConds: {
            termsAndConditions: 'Mga Tuntunin at Kundisyon',
            privacyPolicy: 'Patakaran sa privacy',
            talentPanel: 'Paaralan / Pinapasukan?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Tinanggal',
                deletedTitle: 'Ang posisyon na ito ay hindi na magagamit',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'Mukhang wala na ang pahina na iyong hinahanap.',
            goToHome: 'Pumunta sa pangunahing pahina',
            contactus: 'Makipag-ugnayan sa amin',
        },
        chat: {
            liveNow: 'Live sa chat ngayon!',
            seeAll: 'Lahat',
            schoolSpecificChats: 'Mabilis na pagpasok',
            help: 'Kailangan ng tulong?',
            chatExistsLabel: 'Mayroon nang chat',
        },
        countdown: {
            day: 'araw',
            days: 'araw',
            hour: 'oras',
            hours: 'oras',
            minute: 'minuto',
            minutes: 'minuto',
            second: 'pangalawa',
            seconds: 'segundo',
        },
    },
    spotlight: {
        header: 'Ang aking profile',
        saveChangesToSubmit: 'I-save ang iyong profile para magkabisa',
        saveChanges: 'I-save ang mga pagbabago',
        saveSuccessful: 'Ang iyong mga pagbabago ay matagumpay na nai-save',
        personalDetails: {
            header: 'Personal na detalye',
            firstName: 'Pangalan',
            lastName: 'Apelyido',
            nationality: 'Nasyonalidad',
            gender: 'Kasarian',
            uploadProfileImage: 'Mag-upload ng larawan',
            genderOptions: {
                male: 'Lalaki',
                female: 'Babae',
                other: 'Iba pa',
                none: 'Mas gusto na hindi sabihin',
                unknown: 'Hindi alam',
            },
            wrongFileTypeErrorHeader: 'Di-wastong uri ng file',
            wrongFileTypeErrorDescription: 'Maaari ka lamang mag-upload ng mga imahe',
        },
        summary: { header: 'Buod ng ehekutibo' },
        contactDetails: {
            header: 'Mga detalye sa pakikipag-ugnay',
            contactEmail: 'Makipag-ugnay sa email',
            phoneNumberHeader: 'Numero ng mobile phone',
            countryCode: 'Code ng bansa',
            phoneNumber: 'Numero ng telepono',
            invalidEmail: 'Ang na-type na email ay hindi wastong email.',
            permanentEmail:
                'TANDAAN: Ang pagbabagong ito ay permanente. Maaari mo lamang itakda ang iyong email nang isang beses.',
        },
        languages: {
            header: 'Mga Wika',
            languageLabel: 'Wika',
            levelLabel: 'Antas',
            addLanguage: 'Magdagdag ng bagong wika',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Kahusayan sa elementarya',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Limitadong kakayahan sa pagtatrabaho',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Propesyonal na kasanayan sa pagtatrabaho',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Sapat na propesyonal na kalinanga',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Katutubong katutubong o dwilingwal',
            },
        },
        education: {
            header: 'Edukasyon',
            addEducation: 'Magdagdag ng edukasyon',
            notGraduated: 'Hindi pa nakatapos',
            graduatedIn: 'Nagtapos sa {date}',
            dialog: {
                addNewEducation: 'Magdagdag ng bagong edukasyon',
                degreeTitle: 'Programa',
                institution: 'Institusyon',
                degreeType: 'Degree',
                fieldOfStudy: 'Larangan ng pag-aaral',
                cannotFindField: 'Hindi ko mahanap ang aking field',
                studyStart: 'Start month',
                studyEnd: 'Buwan ng pagtatapos',
                invalidDegreeTitle: 'Kailangan mong punan ang isang pamagat ng iyong programa.',
                invalidSchool: 'Kailangan mong pumili ng isang paaralan.',
                invalidStartDate: 'Mangyaring pumili ng petsa ng pagsisimula.',
                invalidEndDate: 'Mangyaring pumili ng petsa ng pagtatapos.',
                invalidStudyPeriod: 'Hindi ka maaaring makapagtapos bago magsimula ang petsa.',
                invalidDegreeField: 'Mangyaring maglagay ng wastong larangan ng pag-aaral.',
                invalidDegreeLevel: 'Mangyaring pumili ng wastong antas ng iyong degree.',
                selectStartDate: 'Petsa ng pagsisimula',
                selectEndDate: 'Petsa ng Pagtatapos',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Bachelor',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Master',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Agriculture & Forestry',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Applied Sciences & Professions',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Arts, Design & Architechture',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Business & Management',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Computer Science & IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Economics',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Education & Training',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Engineering & Technology',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Environmental Studies & Earth Sciences',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Hospitality, Leisure & Sports',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Humanities',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Journalism & Media',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Law',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60':
                        'Master of Science in Innovation and Business',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Master in Development Management',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Master of Science in Data Science',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Medicine & Health',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'MS in Finance',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': 'MS in International Business Studies',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'MS in Business Analytics',
                    '7d832109-642a-4730-aada-26927eb683ee': 'MS in Management',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Natural Sciences & Mathematics',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Social Sciences',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Iba pa',
                },
            },
        },
        workAuthorization: {
            header: 'Pahintulot sa Trabaho',
            addWorkAuthorization: 'Magdagdag ng pahintulot sa trabaho',
            implicitValue: 'Batay sa iyong nasyonalidad',
            dialog: {
                selectCountry: 'Piliin ang bansa',
                addEuWorkAuthorization: 'Magdagdag ng pahintulot sa trabaho sa EU',
            },
        },
        communication: {
            header: 'Komunikasyon',
            sendMeUpdatesDescription:
                'Mangyaring padalhan ako ng balita ng karera, mga posisyon at mga pag-update ng kumpanya sa pamamagitan ng email',
        },
        errors: {
            imageUpload: {
                title: 'Hindi ma-upload ang imahe.',
                message: 'Masyadong malaki ang imahe!',
            },
        },
        exitDialog: {
            title: 'Mawawala ang hindi nai-save na mga pagbabago',
            message:
                'Sinusubukan mong lumabas sa pahina nang hindi nai-save ang iyong mga pagbabago. Nais mo bang i-save ang iyong profile bago magpatuloy?',
            stayAction: 'Manatili sa pahinang ito',
            saveAction: 'I-save ang profile',
            continueAction: 'Magpatuloy nang hindi nagse-save',
        },
    },
    tests: {
        header: 'Mga Pagsubok',
        unauthorized:
            'Ang mga pagsusulit ay kasalukuyang nasa closed beta. Wala ka pang access sa mga tampok na ito. Magagamit na ang mga ito sa lalong madaling panahon!',
        error: 'Nagkaproblema kapag sinusubukang i-load ang mga pagsubok. Subukang muli mamaya.',
        assessmentModule: { header: 'Ang iyong pagtatasa' },
        completedYourProfile:
            'Kailangan mong kumpletuhin ang iyong profile upang makakuha ng pag-access sa pagtatasa na ito',
        toMyProfile: 'I-edit ang Aking Profile',
    },
    vfair: {
        header: 'EFMD Virtual Events',
        activeNow: 'Nagpapatuloy',
        visibilityPrivate: 'Pribado',
        visibilityNetwork: 'Network',
        visibilityOpen: 'Buksan',
        interested: 'Magparehistro',
        attend: 'Dumalo sa event',
        enterEvent: 'Ipasok ang virtual event',
        notinterested: 'Hindi na ako interesado',
        shownInterest: 'Nirehistro',
        signUpToday: 'Mag palista na ngayon!',
        vfairsInfo:
            'Makipag-ugnay sa mga kumpanya at samahan mula sa buong mundo, sa isang sopistikadong kapaligiran ng patas na patas na trabaho na nagbibigay-daan sa pakikipag-ugnayan sa real-time sa pagitan ng mga nagre-recruit at kandidato. Mag-click sa virtual na kaganapan na interesado ka at mag-sign up upang makatanggap ng mga abiso.',
        recruitingOrgs: 'Mga Recruiting Company at Organisasyon',
        preRegistered: 'Paunang nakarehistro',
        prepareForTheFair: 'Maghanda para sa virtual event',
        privateVFairHeader: 'Campus virtual event',
        privateVFairMessage:
            'Ang virtual na kaganapang ito ay naka-host sa isang platform ng paaralan ng EFMD at samakatuwid ay hindi ma-access mula rito.',
        schoolNotJoinedNetworkEventMessage:
            'Ang iyong paaralan ay hindi pa nag-sign up para sa virtual na kaganapan na ito, makipag-ugnay sa iyong direktor ng programa o departamento ng karera upang humingi ng pakikilahok.',
        companyNotJoinedNetworkEventMessage:
            'Ang iyong samahan ay walang isang aktibong Virtual Booth sa kaganapang ito. Abutin ang Mas Mataas upang humingi ng pakikilahok.',
        pavilions: 'Mga Pavilion',
        general: 'Pangkalahatan',
        allCompanies: 'Lahat ng mga kumpanya',
        lobby: 'Lobby',
        inviteCode: 'Code ng pag-anyaya',
        eventRequiresInvitation: 'Ang kaganapang ito ay nangangailangan ng isang paanyaya',
        haveCode: 'May code ako',
        checkCode: 'Suriin ang code',
        invalidCode: 'Di-wastong code',
        registeredSuccessfully: 'Matagumpay na nakarehistro',
        pavilionTabs: {
            home: 'home',
            companies: 'mga kumpanya',
            articles: 'mga artikulo',
            jobs: 'mga trabaho',
            events: 'events',
        },
        events: {
            noEventsAvailable: 'Walang magagamit na mga kaganapan',
            showCompleted: 'Tapos na ang palabas',
            hideCompleted: 'Nakumpleto na ang itago',
            liveNow: 'Live ngayon',
            joinTheEvent: 'Sumali sa event',
            addToCalendar: 'Idagdag sa kalendaryo',
        },
        links: {
            masterclasses: {
                header: 'Mga Masterclass',
                buttonCaption: 'Panoorin ang mga Masterclass',
                description:
                    'Tingnan ang isang malawak na hanay ng mga de-kalidad na masterclass kabilang ang "CV Optimization to Get Hired", "Rock Your Linkedin Profile" at "Salary Negotiation", bukod sa maraming iba pa, para sa lahat ng mga yugto ng iyong trajectory sa karera',
            },
            detailsmasterclass: { header: 'Dumalo sa masterclass' },
            cv: {
                header: 'Template ng CV',
                buttonCaption: 'Mag-download ng Template ng CV',
                description:
                    'I-access ang Highered ATS-friendly CV template upang makagawa ng isang pinakamainam na propesyonal na impression sa mga nagre-recruit.',
            },
            elevatorPitch: {
                header: 'Elevator Pitch Challenge',
                buttonCaption: 'Ipadala ang iyong pitch',
                description:
                    'Kunin ang "Pitch Perfect Challenge"! Ito ang iyong pagkakataon na maitaguyod ang iyong halaga sa daan-daang mga recruiter mula sa nangungunang mga pandaigdigang kumpanya at organisatons',
            },
        },
        footerHeaders: {
            social: 'Sundan kami para sa karagdagang mga pag-update',
            sponsored: 'Ini-sponsored ng',
            organized: 'Isinaayos ni',
        },
        educationPopup: {
            step00: {
                header: 'Ibahagi ang iyong edukasyon',
                subtitle: 'Upang magpatuloy, ipaalam sa mga employer ang tungkol sa iyo',
                continueLabel: 'Idagdag ang aking edukasyon',
                leaveLabel: 'Alisin',
            },
            step01: { header: 'Sabihin sa amin ang iyong edukasyon' },
            step02: { loadingLabel: 'Sandali lang…' },
            step03: {
                header: 'Nakumpleto ang edukasyon',
                subtitle:
                    'Maaari mo na ngayong ibahagi ang iyong profile at maging mas kawili-wili sa mga employer',
                continueLabel: 'Magpatuloy na tuklasin ang virtual event',
            },
            error: {
                header: 'Wops! May pagkakamaling naganap!',
                subtitle:
                    'Hindi namin nagawang iimbak ang iyong impormasyong pang-edukasyon. Subukang muli mamaya.',
            },
        },
    },
};
